import React, { useState, useRef } from "react";
import TablePagination from '@material-ui/core/TablePagination';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem,
    TableRow, Table,
    TableHead, Select, TextField,
    TableBody, Card, Box,
    TableCell, TableContainer,
    Paper, Typography,
    CircularProgress,
} from "@material-ui/core";
import ActivityService from "./Locality/Service/activityService";
import SubActivityService from "./Locality/Service/subActivityService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import { Grid, } from "@material-ui/core";
import { useFormik } from 'formik';
import { useEffect } from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import StudentService from "./Locality/Service/studentService";
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
}));
export default function StudentDetails(props, history) {
    const tableHeaders = ['First Name', 'Last Name', 'Date Of Birth', 'Age', 'mobileNumber-1', , 'mobileNumber-2', 'UserName', 'Edit', 'Delete'];
    const classes = useStyles();
    const [message, setMessage] = useState("");
    const [teacherList, setTeacherList] = useState([]);
    const [classNameList, setClassNameList] = useState([]);
    const [studentList, setStudentList] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    const [teacherIdList, setTeacherIdList] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(1000);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const [isUploading, setIsUploading] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [uploadErrorOpen, setUploadErrorOpen] = useState(false);
    const [uploadError, setUploadError] = useState({
        message: "",
        invalidClasses: [],
        allowedClassNames: [],
    });
    const [uploadFailedOpen, setUploadFailedOpen] = useState(false);
    const [uploadFailedDetails, setUploadFailedDetails] = useState([]);
    const [pickupPreviewOpen, setPickupPreviewOpen] = useState(false);
    const [pickupPreviewUrl, setPickupPreviewUrl] = useState('');
    const [pickupPreviewScale, setPickupPreviewScale] = useState(1);

    var [studentId, setStudentId] = useState("");
    var [classId, setClassId] = useState("");
    const [addClassList, setAddClassList] = useState([]);
    const [uploadClassId, setUploadClassId] = useState("");
    const [uploadSectionId, setUploadSectionId] = useState("");
    const [uploadSectionList, setUploadSectionList] = useState([]);
    const [addUserPermitionsList, setUserPermitionsList] = useState({ studentDetailsEdit: false, studentDetailsDelete: false });
    const [student, setStudent] = useState({
        classId: '',
        teacherName: '',
        email: '',
        subject: '',
        qualification: '',

        address: '',
        mobileNumber: '',
        attendence: '',
        status: '',
    });
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }

    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    useEffect(() => {
        // getTeacherList();
        // getStudentList();
        getUserPermitionsList();
        getAddClassList();
        return () => {
            setTeacherIdList([]);
            setTeacherList([]);
            setStudentList([]);
            setUserPermitionsList({})
            setAddClassList([]);
        }
    }, []);

    useEffect(() => {
        if (!uploadClassId) {
            setUploadSectionList([]);
            setUploadSectionId("");
            return;
        }
        const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
        SectionService.findSectionList({ schooleId: userDetails.schooleId, classId: uploadClassId, status: true })
            .then((res) => setUploadSectionList(Array.isArray(res) ? res : []))
            .catch(() => setUploadSectionList([]));
        setUploadSectionId("");
    }, [uploadClassId]);

    const handleOpen = () => {
        props.history.push('/app/studentregistration/add')
    };
    const onclick = () => {
        setOpen(true);
    }
    const handleFileChangeFile = (e) => {
        setFile(e.target.files[0]); // Get the selected file
    };

    const handleFileUpload = async () => {
        if (!file) {
            setMessage('Please select a file first.');
            return;
        }

        setIsUploading(true);

        const formData = new FormData();
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        formData.append('excel', file);
        formData.append('schooleId', userDetails.schooleId);
        if (uploadClassId) formData.append('classId', uploadClassId);
        if (uploadSectionId) formData.append('sectionId', uploadSectionId);

        try {
            SubActivityService.studentdRegister('/subactivity/studentregister/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((res) => {
                const failedDetails = res?.failedDetails && Array.isArray(res.failedDetails) ? res.failedDetails : [];
                if (failedDetails.length > 0) {
                    setUploadFailedDetails(failedDetails);
                    setUploadFailedOpen(true);
                } else {
                    alert("Data Imported Successfully.");
                }
                setFile(null);
                if (fileInputRef.current) fileInputRef.current.value = '';
                getStudentList();
                setIsUploading(false);
            }).catch((err) => {
                const data = err?.response?.data;
                let backendMessage = "";
                let invalidClasses = [];
                let allowedClassNames = [];

                if (data && typeof data === "object") {
                    backendMessage = data.message || "";
                    invalidClasses = Array.isArray(data.invalidClasses) ? data.invalidClasses : [];
                    allowedClassNames = Array.isArray(data.allowedClassNames) ? data.allowedClassNames : [];
                } else if (typeof data === "string") {
                    backendMessage = data;
                } else {
                    backendMessage = "Failed to upload. Please check the file format and class names.";
                }

                setUploadError({
                    message: backendMessage,
                    invalidClasses,
                    allowedClassNames,
                });
                setUploadErrorOpen(true);
                setIsUploading(false);
            });


        } catch (error) {
            console.error('Error uploading file:', error);
            setMessage('Failed to upload file.');
            setIsUploading(false);
        }
    };
    const filteredStudents = studentList.filter(student => {
        return student.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) || student.admissionNumber?.includes(searchTerm);
    }


    );

    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const groupByStudentId = (data) => {
        return data.reduce((acc, item) => {
            const studentId = item.studentId._id;
            if (!acc[studentId]) {
                acc[studentId] = {
                    studentDetails: {
                        _id: studentId,
                        firstName: item.studentId.firstName,
                        lastName: item.studentId.lastName,
                    },
                    activities: [],
                };
            }
            acc[studentId].activities.push(item);
            return acc;
        }, {});
    };
    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));

        const keys = {
            schooleId: userDetails.schooleId,
            ...(uploadClassId && { classId: uploadClassId }),
            ...(uploadSectionId && { sectionId: uploadSectionId }),
        };
        StudentService.findStudentList(keys).then((res) => {
            
            console.log('Student List Response:', res); // Debug log

            const mapResult = res.map((student) => {
                console.log('Individual student data:', student); // Debug log
                return { 
                    ...student, 
                    fullName: `${student.firstName} ${student.lastName}`,
                    userId: student.userId || {} // Ensure userId exists
                }
            });
            console.log('Mapped Result:', mapResult); // Debug log
            setStudentList(mapResult);
        }).catch((err) => {
            
        });

    };
    // const getTeacherList = () => {
    //     TeacherService.getAllTeacher().then((res) => {
    //         setTeacherList(res);
    //     }).catch((err) => {

    //     });
    // }
    const getUserPermitionsList = () => {
        const userPermitions = ActivityService.userPermitions();

        setUserPermitionsList(userPermitions);
    }
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
            if (userDetails.role === "TEACHER") {
                res = res.filter(res => res._id === userDetails.classId);
            }
            setAddClassList(res);
            if (res.length > 0) {
                setClassId(res[0]._id);
                setUploadClassId(res[0]._id);
                getStudentList({ target: { value: res[0]._id } });
                onSubmit();
            }

        }).catch((err) => {
            // setError(err.message);
        });
    }

    const getStudentList = () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        StudentService.getAllStudent(userDetails.schooleId).then((res) => {
            const mapResult = res.map((student) => {
                return { ...student, fullName: `${student.firstName} ${student.lastName} ` }
            })
            setStudentList(mapResult);
        }).catch((err) => {
            console.error("Error fetching student list:", err);
        });
    };
    // const getStudentList = (event, obj) => {
    //     const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    //     const getStuList = {  classId:event.target.value}; 


    //     StudentService.getAllStudentById(userDetails.schooleId, getStuList
    //     ).then((res) => {

    //         const studentDetails = res.map(res => {
    //             return { _id: res._id, studentName: `${res.firstName} ${res.lastName}` };
    //         });

    //         setStudentList(studentDetails);


    //     }).catch((err) => {
    //         // setError(err.message);
    //     });
    // }

    // const editActivityTabel = (tabel) => {
    //     const obj = JSON.parse(JSON.stringify(tabel));
    //     obj.superActivityId = tabel.superActivityId ? tabel.superActivityId._id : '';
    //     obj.classId = tabel.classId ? tabel.classId._id :'';
    //     // obj.activityId = sub.activityId ? sub.activityId._id : '';
    //     setTabel(obj)
    //     handleOpen()
    // }

    const editStudent = (id, student) => {

        const obj = JSON.parse(JSON.stringify(student));
        obj.classId =
            student?.classId
                ? (typeof student.classId === 'object' ? (student.classId?._id || '') : String(student.classId))
                : '';
        obj.sectionId =
            student?.sectionId
                ? (typeof student.sectionId === 'object' ? (student.sectionId?._id || '') : String(student.sectionId))
                : '';

        props.history.push(`/app/studentregistration/${id}`);
        setStudent(obj);
        // handleOpen();
        setIsEditMode(true)
        setEditId(editId ? null : 1)


    }
    const handleFileChange = (e) => {
        setFile(e.target.files[0]); // Get the selected file
    };
    const deleteStudent = (studentdelete) => {
        if (!studentdelete) return;
        const studentId = typeof studentdelete === 'object' ? studentdelete._id : studentdelete;
        const studentName = typeof studentdelete === 'object' && studentdelete
            ? `${studentdelete.firstName || ''} ${studentdelete.lastName || ''}`.trim() || 'this student'
            : 'this student';
        const confirmMessage = `Are you sure you want to delete "${studentName}"?\n\nThis action cannot be undone. All associated data will be permanently removed.`;
        if (window.confirm(confirmMessage)) {
            StudentService.deleteStudent(studentId).then((res) => {
                getStudentList();
                alert(`Student "${studentName}" has been deleted successfully.`);
            }).catch((err) => {
                alert(err?.response?.data?.message || `Failed to delete student "${studentName}". Please try again.`);
            });
        }
    };
    const deleteAllStudents = async () => {
        if (!studentList.length) {
            alert('There are no students to delete.');
            return;
        }
        const firstConfirm = window.confirm(
            'Are you sure you want to delete ALL student records shown in this list?\n\nThis operation cannot be undone.'
        );
        if (!firstConfirm) return;

        const secondConfirm = window.confirm(
            'FINAL CONFIRMATION:\n\nThis will permanently delete ALL student records for this school from the system.\n\nClick OK to proceed, or Cancel to abort.'
        );
        if (!secondConfirm) return;

        setIsDeleting(true);
        try {
            const ids = studentList
                .map((s) => (typeof s === 'object' ? s._id : s))
                .filter(Boolean);

            await StudentService.deleteAllStudents({ studentIds: ids });
            alert('All student records have been deleted successfully.');
            setStudentList([]);
        } catch (err) {
            alert(
                err?.response?.data?.message ||
                'Failed to delete all students. Some records may still remain. Please try again.'
            );
            getStudentList();
        } finally {
            setIsDeleting(false);
        }
    };
    const formik = useFormik({
        initialValues: student,
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            //   StudentService.upadeStudent(values).then((res) => {
            //     alert(" Updated Successfully.");
            //   })
            //     .catch((err) => {
            //       alert(err.response.data.message)
            //     })
        },
    });

    return (
        <>
            <PageTitle title="Student Details" button={<Button
                variant="contained" onClick={handleOpen}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Student Registration
            </Button>} />
            <Card sx={{ maxWidth: 345 }}>
                <Box   >


                    <Grid container spacing={2} columns={12} style={{ margin: 10, }}  >
                        <Grid item xs={6} sm={6} md={4}>
                            <FormControl fullWidth size="small" style={{ minWidth: 150, marginBottom: 8 }}>
                                <InputLabel id="upload-class-label">Class </InputLabel>
                                <Select
                                    labelId="upload-class-label"
                                    id="upload-class"
                                    value={uploadClassId}
                                    onChange={(e) => setUploadClassId(e.target.value)}
                                    label="Class (optional)"
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {addClassList.map((c) => (
                                        <MenuItem key={c._id} value={c._id}>{c.className}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            </Grid>  
                            <Grid item xs={6} sm={6} md={4}>
                            <FormControl fullWidth size="small" style={{ minWidth: 150, marginBottom: 8 }} disabled={!uploadClassId || uploadSectionList.length === 0}>
                                <InputLabel id="upload-section-label">Section (optional)</InputLabel>
                                <Select
                                    labelId="upload-section-label"
                                    id="upload-section"
                                    value={uploadSectionId}
                                    onChange={(e) => setUploadSectionId(e.target.value)}
                                    label="Section (optional)"
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {uploadSectionList.map((s) => (
                                        <MenuItem key={s._id} value={s._id}>{s.sectionName}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                            <Button
                                variant="contained"
                                size="small"
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', marginBottom: 8, minHeight: 40 }}
                                onClick={() => { setpg(0); onSubmit(); }}
                            >
                                Search
                            </Button>
                            </Grid>
                            <Grid item xs={12}>
                            <input ref={fileInputRef} type="file" onChange={handleFileChange} accept=".xlsx,.xls" />
                            <Button
                                style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', marginTop: 8 }}
                                onClick={handleFileUpload}
                                disabled={isUploading}
                            >
                                {isUploading ? (
                                    <>
                                        Uploading...
                                        <CircularProgress size={18} style={{ marginLeft: 8, color: 'white' }} />
                                    </>
                                ) : (
                                    'Upload Excel'
                                )}
                            </Button>
                            <br></br>
                            <a
                            
                                href="https://artistimages.blob.core.windows.net/artistimage/student registration sample excel (12) (7) (4).xlsx"
                                download="Sample.pdf"
                            >
                                download Sample Format
                            </a>
                            </Grid>
                            <Box
                                component="span"
                                display="block"
                                mt={1.5}
                                px={1.5}
                                py={1}
                                borderRadius={1}
                                bgcolor="rgba(15, 59, 98, 0.06)"
                                borderLeft="3px solid rgb(15 59 98)"
                            >
                                <Typography variant="caption" style={{ color: '#c62828', fontStyle: 'italic' }}>
                                    Note: Section is optional for both search and Excel upload.
                                </Typography>
                            </Box>
                            <br></br>
                            {message && <p>{message}</p>}



                    

                        {/* <Grid item xs={6} sm={6} md={4}  >
                                    <FormControl className={classes.formControl} fullWidth
                                    >
                                        <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="searchClassId"
                                            label="selectClass"


                                            onChange={e => { setSearchClassId(e.target.value); getStudentList(e) }}
                                            value={searchClassId}
                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>

                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>{className}

                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                </Grid>
                           
                               
                                <Grid item xs={6} sm={6} md={4}>
                                    <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                                        type="button"

                                        onClick={() => onSubmit()} variant="contained"
                                    >
                                        Search</Button>
                                </Grid> */}

                    </Grid>


                </Box>
            </Card>
            <br></br>
            <Grid container spacing={4}>
                <Grid item xs={12}>

                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                padding: '10px',
                                alignItems: 'center',
                                gap: 16,
                            }}
                        >
                            <TextField
                                label="Search By Student name"
                                variant="outlined"
                                size="small"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ minWidth: 280 }}
                            />
                            {/* <Button
                                style={{ backgroundColor: '#c62828', color: 'white' }}
                                onClick={deleteAllStudents}
                                disabled={!studentList.length || isDeleting}
                            >
                                {isDeleting ? 'Deleting...' : 'Delete All Students'}
                            </Button> */}
                        </div>
                                                <TableContainer component={Paper} style={{ maxHeight: 500 }}>

                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    <StyledTableCell>Profile</StyledTableCell>
                                    <StyledTableCell>Admission Number</StyledTableCell>
                                    <StyledTableCell>First Name</StyledTableCell>
                                    <StyledTableCell>Middle Name</StyledTableCell>
                                    <StyledTableCell>Last Name</StyledTableCell>
                                    <StyledTableCell>Gender</StyledTableCell>
                                    <StyledTableCell>Mother Name</StyledTableCell>
                                    <StyledTableCell>Father Name</StyledTableCell>
                                    <StyledTableCell>Parent Mobile</StyledTableCell>
                                    <StyledTableCell>Date Of Birth</StyledTableCell>
                                    <StyledTableCell>Class</StyledTableCell>
                                    <StyledTableCell>Section</StyledTableCell>
                                    <StyledTableCell>Allergies</StyledTableCell>
                                    <StyledTableCell>Authorized Pickup(s)</StyledTableCell>
                                    <StyledTableCell>Special Needs</StyledTableCell>
                                    <StyledTableCell>Aadhaar Card</StyledTableCell>
                                    <StyledTableCell>Birth Certificate</StyledTableCell>
                                    <StyledTableCell>Aadhaar Number</StyledTableCell>
                                    <StyledTableCell>Address</StyledTableCell>
                                    <StyledTableCell>User Name</StyledTableCell>
                                    {addUserPermitionsList && addUserPermitionsList?.studentDetailsEdit ?
                                        <StyledTableCell>Edit</StyledTableCell> : null}
                                    {addUserPermitionsList && addUserPermitionsList?.studentDetailsDelete ?
                                        <StyledTableCell>Delete</StyledTableCell> : null}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredStudents.slice(pg * rpg, pg * rpg + rpg).map((student) => (
                                    <TableRow key={student._id}>
                                        <TableCell className="pl-3 fw-normal">
                                            {student.profileURL || student.imageURL?.[0] ? (
                                                <img
                                                    src={student.profileURL || student.imageURL?.[0]}
                                                    alt="Profile"
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = ''; // Clear src to trigger fallback
                                                    }}
                                                    style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                    }}
                                                />
                                            ) : (
                                                <AccountCircleIcon style={{ fontSize: 40, color: '#999' }} />
                                            )}
                                        </TableCell>


                                        <TableCell className="pl-3 fw-normal" >{student.admissionNumber}</TableCell>

                                        <TableCell className="pl-3 fw-normal" >{student.firstName}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.middleName ? String(student.middleName) : '—'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.lastName}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.gender ? String(student.gender) : '—'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.motherName ? String(student.motherName) : '—'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.fatherName ? String(student.fatherName) : '—'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.mobileNumber ? String(student.mobileNumber) : '—'}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{dateAndTime(student.dob)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {student.classId ? (typeof student.classId === 'object' ? student.classId.className : '') : ''}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {(student.sectionId && typeof student.sectionId === 'object' && (student.sectionId.sectionName != null && student.sectionId.sectionName !== '')) ? String(student.sectionId.sectionName) : '—'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {student.allergies && String(student.allergies).trim() && String(student.allergies).toLowerCase() !== 'no'
                                                ? String(student.allergies)
                                                : 'No'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {Array.isArray(student.authorizedPickups) && student.authorizedPickups.length > 0 ? (
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                                    {student.authorizedPickups.slice(0, 5).map((p, idx) => (
                                                        <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                            {p?.photoURL ? (
                                                                <img
                                                                    src={p.photoURL}
                                                                    alt={`Pickup ${idx + 1}`}
                                                                    onClick={() => {
                                                                        setPickupPreviewUrl(p.photoURL);
                                                                        setPickupPreviewScale(1);
                                                                        setPickupPreviewOpen(true);
                                                                    }}
                                                                    style={{ width: 28, height: 28, objectFit: 'cover', borderRadius: 4 }}
                                                                />
                                                            ) : null}
                                                            <span>
                                                                {p?.name ? String(p.name) : '—'}
                                                                {p?.mobileNumber ? ` — ${String(p.mobileNumber)}` : ''}
                                                            </span>
                                                        </div>
                                                    ))}
                                                    {student.authorizedPickups.length > 5 ? (
                                                        <span style={{ color: '#666' }}>
                                                            +{student.authorizedPickups.length - 5} more
                                                        </span>
                                                    ) : null}
                                                </div>
                                            ) : (
                                                <span>
                                                    {student.authorizedPickupName || student.authorizedPickupMobileNumber
                                                        ? `${student.authorizedPickupName ? String(student.authorizedPickupName) : '—'}${student.authorizedPickupMobileNumber ? ` — ${String(student.authorizedPickupMobileNumber)}` : ''}`
                                                        : '—'}
                                                </span>
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {student.specialNeeds ? String(student.specialNeeds) : '—'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {Array.isArray(student.imageURL) && student.imageURL.length > 0 ? (
                                                <a href={student.imageURL[0]} target="_blank" rel="noreferrer">View</a>
                                            ) : (
                                                '—'
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal">
                                            {student.birthCertificateURL ? (
                                                <a href={student.birthCertificateURL} target="_blank" rel="noreferrer">View</a>
                                            ) : (
                                                '—'
                                            )}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal" >
                                            {student.aadharNo || student.adharNo ? String(student.aadharNo || student.adharNo) : '—'}
                                        </TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.address ? String(student.address) : '—'}</TableCell>
                                        <TableCell className="pl-3 fw-normal" >{student.userId?.serialNumber}</TableCell>
                                        {addUserPermitionsList.studentDetailsEdit ?
                                            <TableCell>
                                                <EditIcon style={{ cursor: 'pointer' }} onClick={() => editStudent(student._id, student)} >
                                                </EditIcon >
                                            </TableCell> : null}
                                            
                                        {addUserPermitionsList.studentDetailsDelete ?
                                            <TableCell>
                                                <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteStudent(student)} />
                                            </TableCell> : null}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 50000, 100000]}
                            count={studentList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>

            {/* Authorized pickup image preview */}
            <Dialog
                open={pickupPreviewOpen}
                onClose={() => {
                    setPickupPreviewOpen(false);
                    setPickupPreviewUrl('');
                    setPickupPreviewScale(1);
                }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Authorized pickup photo</DialogTitle>
                <DialogContent dividers>
                    <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1} style={{ gap: 8 }}>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', minWidth: 44 }}
                            onClick={() => setPickupPreviewScale((s) => Math.min(5, Number((s + 0.25).toFixed(2))))}
                            disabled={!pickupPreviewUrl}
                        >
                            +
                        </Button>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: 'rgb(15 59 98)', color: 'white', minWidth: 44 }}
                            onClick={() => setPickupPreviewScale((s) => Math.max(1, Number((s - 0.25).toFixed(2))))}
                            disabled={!pickupPreviewUrl || pickupPreviewScale <= 1}
                        >
                            -
                        </Button>
                        <Button
                            variant="contained"
                            style={{ backgroundColor: '#6c757d', color: 'white' }}
                            onClick={() => setPickupPreviewScale(1)}
                            disabled={!pickupPreviewUrl || pickupPreviewScale === 1}
                        >
                            Reset
                        </Button>
                        <Typography variant="caption" style={{ marginLeft: 8, color: '#0f3b62ad' }}>
                            Zoom: {Math.round(pickupPreviewScale * 100)}%
                        </Typography>
                    </Box>
                    {pickupPreviewUrl ? (
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            style={{
                                overflow: 'auto',
                                maxHeight: '70vh',
                                borderRadius: 8,
                            }}
                        >
                            <img
                                src={pickupPreviewUrl}
                                alt="Authorized pickup"
                                style={{
                                    transform: `scale(${pickupPreviewScale})`,
                                    transformOrigin: 'center',
                                    objectFit: 'contain',
                                    borderRadius: 8,
                                }}
                            />
                        </Box>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No image to preview.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setPickupPreviewOpen(false);
                            setPickupPreviewUrl('');
                            setPickupPreviewScale(1);
                        }}
                        style={{ backgroundColor: '#6c757d', color: 'white' }}
                        variant="contained"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Upload in progress – do not close until upload finishes */}
            <Dialog
                open={isUploading}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Uploading data...</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" py={2}>
                        <CircularProgress size={48} style={{ marginBottom: 16 }} />
                        <Typography variant="body1" align="center" gutterBottom>
                            Please wait until all data is uploaded.
                        </Typography>
                        
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Deleting students – do not close until delete finishes */}
            <Dialog
                open={isDeleting}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="xs"
            >
                <DialogTitle>Deleting students...</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="center" py={2}>
                        <CircularProgress size={48} style={{ marginBottom: 16 }} />
                        <Typography variant="body1" align="center" gutterBottom>
                            Please wait until all students are deleted.
                        </Typography>
                       
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Upload error popup */}
            <Dialog
                open={uploadErrorOpen}
                onClose={() => setUploadErrorOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Upload Error</DialogTitle>
                <DialogContent dividers>
                    {uploadError.message && (
                        <Typography variant="body1" gutterBottom>
                            {uploadError.message}
                        </Typography>
                    )}

                    {uploadError.invalidClasses && uploadError.invalidClasses.length > 0 && (
                        <div
                            style={{
                                marginTop: 12,
                                marginBottom: 12,
                                padding: '8px 12px',
                                borderRadius: 6,
                                backgroundColor: '#ffebee', // light red
                                borderLeft: '4px solid #f44336',
                            }}
                        >
                            <Typography variant="subtitle2" gutterBottom style={{ color: '#b71c1c' }}>
                                Invalid class names found in the file:
                            </Typography>
                            <ul style={{ marginTop: 0, paddingLeft: 20 }}>
                                {uploadError.invalidClasses.map((name, idx) => (
                                    <li key={`${name}-${idx}`}>
                                        <Typography variant="body2" style={{ color: '#d32f2f' }}>
                                            {name}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {uploadError.allowedClassNames && uploadError.allowedClassNames.length > 0 && (
                        <div
                            style={{
                                marginTop: 8,
                                padding: '8px 12px',
                                borderRadius: 6,
                                backgroundColor: '#e8f5e9', // light green
                                borderLeft: '4px solid #4caf50',
                            }}
                        >
                            <Typography variant="subtitle2" gutterBottom style={{ color: '#1b5e20' }}>
                                Allowed class names:
                            </Typography>
                            <ul style={{ marginTop: 0, paddingLeft: 20 }}>
                                {uploadError.allowedClassNames.map((name, idx) => (
                                    <li key={`${name}-allowed-${idx}`}>
                                        <Typography variant="body2" style={{ color: '#2e7d32' }}>
                                            {name}
                                        </Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUploadErrorOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Upload completed with failed rows – which field / error per row */}
            <Dialog
                open={uploadFailedOpen}
                onClose={() => setUploadFailedOpen(false)}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Upload completed with errors</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        The following rows could not be imported. Check the field and error to fix your file.
                    </Typography>
                    <TableContainer component={Paper} style={{ marginTop: 12, maxHeight: 360 }}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 600 }}>Student name</TableCell>
                                    <TableCell style={{ fontWeight: 600 }}>Field</TableCell>
                                    <TableCell style={{ fontWeight: 600 }}>Error</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {uploadFailedDetails.map((row, idx) => (
                                    <TableRow key={`failed-${idx}`}>
                                        <TableCell>{row.name || '—'}</TableCell>
                                        <TableCell>{row.field || '—'}</TableCell>
                                        <TableCell>{row.message || '—'}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setUploadFailedOpen(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


